exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.split-tab-active[data-v-c9440bda] {\n  background-color: #34458D !important;\n  color: #fff !important;\n}\n.split-tab-inactive[data-v-c9440bda] {\n  background-color: #e6e6e6 !important;\n  color: #4b4b4b !important;\n}\n.link_list[data-v-c9440bda] {\n  margin-left: auto;\n  margin-top: -30px;\n}\n@media screen and (max-width: 896px) {\n.link_list[data-v-c9440bda] {\n    order: -1;\n    padding-top: 0;\n    margin-top: 0;\n    margin-left: 0;\n    text-align: right;\n    width: 100%;\n}\n}\n", ""]);

// exports
